module.exports = __webpack_public_path__ + "img/moren.92893a92.png";